import { useSources } from '../hooks/useSources';
import { createHOCWithHookInside } from './createHOCWithHookInside';

/**
 * @deprecated use "useSources"
 */
export const withSources = createHOCWithHookInside('WithSources', useSources);
